import { PrintQueueStatusSchema } from "@redotech/redo-fulfillment-printing-common/print-queue-status";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getPrintQueueStatus = unaryRpc({
  name: "getPrintQueueStatus",
  input: z.object({}),
  output: PrintQueueStatusSchema,
  mock: { total: 0, completed: 0, failed: [], inFlight: [], activeJob: null },
});
